/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Preview_Empty_BodyInputs */

const cs_blog_preview_empty_body = /** @type {(inputs: Blog_Preview_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte příspěvek vlevo pro náhled, nebo vytvořte nový článek.`)
};

const en_blog_preview_empty_body = /** @type {(inputs: Blog_Preview_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a post on the left to preview, or create a new article.`)
};

/**
* | output |
* | --- |
* | "Select a post on the left to preview, or create a new article." |
*
* @param {Blog_Preview_Empty_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_preview_empty_body = /** @type {((inputs?: Blog_Preview_Empty_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Preview_Empty_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_preview_empty_body(inputs)
	return cs_blog_preview_empty_body(inputs)
});